import React, { FC, memo } from 'react';
import { Row, TableRowProps } from 'react-table';

type TProps = {
  row: Row<any>;
  rowProps: TableRowProps;
  index: number;
};

const FnBodyRow: FC<TProps> = ({ row, rowProps, index }) => (
  <React.Fragment key={index}>
    <tr {...rowProps}>
      {row.cells.map((cell: any, j) => {
        return (
          // @ts-ignore
          <td key={j} {...cell.getCellProps()}>
            {cell.render('Cell')}
          </td>
        );
      })}
    </tr>
  </React.Fragment>
);

export default memo(FnBodyRow);
